<template>
  <v-dialog v-model="isShow"  persistent
            max-width="250px" >
    <v-card>

      <v-card-text style="text-align: center;font-size: 20px;color: black">
     loading
      </v-card-text>

      <v-progress-linear
          height="15"
          indeterminate
          color="#3b5694">

      </v-progress-linear>

    </v-card>

  </v-dialog>

</template>

<script>

    export default {
      name:'Progress',
      props: {
          isShow: {
              default: false,
          },
      },
        data() {
            return {
                options: {
                    message: '',
                }
            }

        },




    }
</script>

